
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `Mishima's Head by Mario Bellatin | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `In Mishima’s Head, Mario Bellatin trails his sometimes avatar, the Japanese literary icon Yukio Mishima, across a cyclorama of figures and phantoms, where images and memories flash like photographs in passing view. His ritual decapitation complete, Mishima’s wanderings are headless and propulsive. Histories and stories come and go. A writer’s torments are forever.`);


  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-Three/MarioBellatin_08_Mockup1.webp', '../../Series-Three/MarioBellatin_08_Mockup2.webp', '../../Series-Three/MarioBellatin_08_Mockup3.webp']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>Mishima's Head</h1>
            <div className='productAuthor'>Mario Bellatin</div>
            <div className='productTranslator'>Translated by Shook</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798990416550'} />
            <div className='productPrice'>$14.99 USD</div>
          </div>
          <div className='productExcerpt'>
            The head and the creation of words. Mishima had realized that there could not be one without the other. He had realized that if he had had a head like everyone else, he would be dead in the same way the rest die. Definitively.

          </div>

          <div className='productDescription'>In <em>Mishima’s Head</em>, Mario Bellatin trails his sometimes avatar, the Japanese literary icon Yukio Mishima, across a cyclorama of figures and phantoms, where images and memories flash like photographs in passing view. His ritual decapitation complete, Mishima’s wanderings are headless and propulsive. Histories and stories come and go. A writer’s torments are forever.
          </div>
          <div className='productDescription'>
            <p>
              The oft-hooded master of letters <strong>Mario Bellatin</strong> is widely hailed as one of Mexico’s greatest living writers. An uncategorizable avant-gardist, practicing Sufi and author of cult novels <em>Beauty Salon</em> (1994) and <em>Jacob the Mutant</em> (2002), Bellatin has channeled Yukio Mishima as an emblem of insistent self-fashioning in his previous works <em>Flowers</em> and <em>Mishima’s Illustrated Biography</em> (translated as a two-part volume by Kolin Jordan, 2014). He directs the Escuela Dinámica de Escritores in Mexico City.
            </p>
            <p>
              <strong>Shook</strong> is a poet, translator, and filmmaker raised in Mexico City. Shook is the founder of the nonprofit publishing house Phoneme Media, where they have edited over 30 books translated from 26 languages, among these the first ever literary translations from Uyghur and Lingala. Shook has translated over 15 books from Spanish and Isthmus Zapotec, including Mario Bellatin’s <em>The Large Glass: Three Autobiographies</em> (2014), <em>Shiki Nagaoka: A Nose for Fiction</em> (2012) and <em>The Uruguayan Book of the Dead</em> (2021).

            </p>
            <p><em>Back cover photo: Graciela Iturbide</em></p>
          </div>
          <div className='productMetadata'>
            <div>Series III, No. 8</div>
            <div>Summer 2025</div>
            <div>ISBN 979–8–990416–55–0</div>
            <div>4.125 x 2.75 inches</div>
            <div>176 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}